/* AI 자유대화 카메라(표정) — 2026-10-01 (OWNER '카메라 연동 시작')
 *
 * 무엇을 하나
 *   학생이 켜면 앞면 카메라·웹캠 영상을 이 기기 안에서만 분석해(MediaPipe Face Landmarker, 브라우저 WASM)
 *   '웃음 / 화면에서 벗어남 / 굳은 표정' 같은 거친 신호만 뽑는다. 그 신호를 한 줄 힌트로 바꿔
 *   (2026-10-01 추가 '모션 감지 기능') 움직임 정도(작은 흑백 화면 차이)와 고개 끄덕임·가로젓기도 본다.
 *   AI 지시문 끝에 붙여 대화 속도·분위기만 맞춘다.
 *
 * 지키는 것 (2026-10-01 OWNER 확인: 대화 분위기 조절에만, 결과지 미반영, 기기 안 처리, 복장 제외)
 *   · 영상·사진·얼굴 좌표는 서버로 보내지 않고 저장하지 않는다. 밖으로 나가는 것은 지시문 속 한 줄 힌트(글)뿐.
 *   · 검사 결과·결과지에는 쓰지 않는다. 얼굴로 누구인지 알아내지 않는다(식별 없음). 옷차림은 보지 않는다.
 *   · 처음 켤 때 동의 화면: 만 14세 미만이면 보호자(또는 선생님) 동의 확인 체크가 있어야 켜진다(개인정보보호법 제22조의2).
 *   · 켜져 있는 동안 작은 미리보기와 '카메라 켜짐' 표시, 언제든 '끄기'·'동의 취소'.
 *   · 키오스크(kiosk-on)는 버튼을 보이지 않는다(저사양 CPU).
 *   · 표정으로 감정을 단정하지 않는다. AI 에게도 '표정을 언급·평가하지 말고 톤만 맞춰'라고 준다.
 *
 * 파일: /vendor/mediapipe-1.0.1/ (vision_bundle.mjs · wasm/ · face_landmarker.task, tools/fetch-mediapipe.sh 로 받음, 약 15MB, 처음 한 번)
 * 연결: pia-main.js 가 지시문을 만들 때 window.piaCamHint() 를 붙인다. 서버·kiosk.js 무변경.
 * 끄기(현장): localStorage 'pia_cam'='0' 이면 버튼 자체를 숨긴다.
 */
(function () {
  'use strict';
  if (window.__piaCam) return;
  window.__piaCam = 1;

  var VENDOR = '/vendor/mediapipe-1.0.1/';
  /* [2026-10-04 고도화] 표정 분석을 작업 스레드(pia-camera-worker.js)에서 돌린다 — 화면·음성이 끊기지 않게.
     워커를 못 쓰거나 준비에 실패하면 예전처럼 화면 스레드에서 분석한다(간격 조절·보낸 뒤 3초 쉼 그대로).
     끄기: localStorage pia_cam_worker='0'. 워커 파일을 고치면 WORKER_VER 를 올린다(캐시). */
  var WORKER_VER = '1';
  var SELF_SRC = ''; try { SELF_SRC = (document.currentScript && document.currentScript.src) || ''; } catch (e) {}
  /* [2026-10-10 IMP-PIA-BUNDLE] 이 파일은 pia-bundle.min.js 안에 묶여 실린다 — 파일 이름이 아니라 '마지막 / 뒤(이름·?v=)'를 떼어 같은 폴더(js/)를 얻는다. */
  var WORKER_URL = (SELF_SRC ? SELF_SRC.replace(/[^\/?#]*([?#].*)?$/, '') : 'js/') + 'pia-camera-worker.js?v=' + WORKER_VER;
  var worker = null, wReady = false, wPending = 0, wSeq = 0, wDelegate = '', wErrs = 0, useWorker = false;
  function workerAllowed() {
    try { if (localStorage.getItem('pia_cam_worker') === '0') return false; } catch (e) {}
    return typeof Worker !== 'undefined' && typeof createImageBitmap === 'function';
  }
  function loadWorker() {
    return new Promise(function (resolve, reject) {
      var w; try { w = new Worker(WORKER_URL); } catch (e) { reject(e); return; }
      var to = setTimeout(function () { try { w.terminate(); } catch (e) {} reject(new Error('준비 시간 초과')); }, 25000);
      w.onmessage = function (ev) {
        var m = ev.data || {};
        if (m.type === 'ready') { clearTimeout(to); worker = w; wReady = true; wDelegate = m.delegate || ''; wErrs = 0; w.onmessage = onWorkerMsg; resolve(); }
        else if (m.type === 'error') { clearTimeout(to); try { w.terminate(); } catch (e) {} reject(new Error(m.message || '워커 오류')); }
      };
      w.onerror = function (e) { clearTimeout(to); try { w.terminate(); } catch (_) {} reject(new Error('워커 오류: ' + (e && e.message || ''))); };
      w.postMessage({ type: 'init', vendor: location.origin + VENDOR });
    });
  }
  function dropWorker(why) {
    log('작업 스레드 중단 → 화면 스레드로', why || '');
    try { if (worker) worker.terminate(); } catch (e) {}
    worker = null; wReady = false; wPending = 0; useWorker = false;
    if (on) loadModel().catch(function (e) { lastErr = String(e && e.message || e); console.error('[camera] 화면 스레드 분석 준비 실패', e); stop('model'); });
  }
  function onWorkerMsg(ev) {
    var m = ev.data || {};
    if (m.type !== 'res') return;
    wPending = 0;
    if (m.err) { lastErr = m.err; if (++wErrs >= 3) dropWorker(m.err); return; }
    if (!on) return;
    try {
      wErrs = 0;
      if (++detN > 2) detAvg = detAvg ? detAvg * 0.7 + m.dt * 0.3 : m.dt;
      curTalk = false;
      var smp = toSample(m.res);
      smp.motion = motionLevel();
      samples.push(smp);
      var cut = performance.now() - WINDOW_MS * 2;
      while (samples.length && samples[0].t < cut) samples.shift();
    } catch (e) { lastErr = String(e && e.message || e); console.error('[camera] 분석 결과 처리 실패', e); }
  }
  var CONSENT_KEY = 'pia_cam_consent_v2';   /* v2(2026-10-01): 졸리면 쉬어 가자고 권하는 기능 추가 → 다시 동의받음 */
  var SAMPLE_MS = 200;          /* 초당 5회 — 고개 끄덕임(0.3~0.5초 주기)을 잡을 만큼, CPU 는 아낀다 */
  var WINDOW_MS = 20000;        /* 최근 20초로 힌트를 만든다 */
  var MIN_SAMPLES = 8;            /* 느린 기기는 분석 간격이 1~2초라 20초에 10~20장 — 8장부터 판단 */
  var GESTURE_MS = 8000;        /* 끄덕임·가로젓기는 최근 8초 안의 것만 힌트로 쓴다 */
  var HEAD_AMP = 0.05;          /* 코끝 이동(얼굴 너비 대비)이 이만큼 넘게 오가야 한 번 */
  var RESTLESS = 0.05;          /* 화면 차이 평균(0~1)이 이 이상이면 많이 움직임 — 현장 값으로 조정(state().motionAvg) */
  /* 졸림(2026-10-01 OWNER): 눈에 보이는 행동만 본다 — 눈 감김(eyeBlink)과 하품(jawOpen).
     태블릿을 내려다보면 눈꺼풀이 내려와 eyeBlink 가 0.4~0.5 까지 오르므로 감김 기준은 높게 잡는다.
     현장 값은 state().closed·longClose·yawns 로 보고 조정. */
  var EYE_CLOSED = 0.7;         /* 양 눈 eyeBlink 평균이 이 이상이면 감김 */
  var PERCLOS = 0.35;           /* 얼굴 표본 중 감김 비율 */
  var LONG_CLOSE_MS = 2000;     /* 한 번에 이만큼 넘게 감고 있으면 */
  var YAWN_JAW = 0.5, YAWN_MS = 1200;   /* 입이 이만큼 벌어진 채 1.2초 넘으면 하품 한 번 */
  var SLEEPY_ASK_MS = 180000;   /* 쉬어 가자는 권유는 3분에 한 번만 */
  /* [2026-10-04 고도화] 신호 확장 — 놀람(눈썹 올라감 + 눈 커짐 또는 입 벌어짐, 최근 8초)과
     집중(화면을 보며 거의 움직이지 않고 눈을 뜨고 있음). 둘 다 말투·질문 깊이 조정에만 쓰고 학생에게 말하지 않는다.
     늘 눈썹을 올리고 있는 얼굴은 놀람으로 보지 않는다(창 안에서 40% 넘게 지속되면 제외). */
  var BROW_UP = 0.5, EYE_WIDE = 0.3, JAW_SURPRISE = 0.3;

  var on = false, stream = null, video = null, lm = null, loopT = null, samples = [], busy = false, lastErr = '';
  /* 성능(2026-10-01 카메라+마이크 동시 점검): 표정 분석은 화면 스레드에서 돈다. GPU 가 없어 CPU 로 돌면
     한 장에 ~150ms 라, 초당 5장이면 화면 스레드의 70% 를 먹어 맞장구·첫 문장 소리가 2배 늦어졌다.
     - 분석 간격을 실측 분석 시간의 6배 이상으로(화면 스레드 ~15% 이하) — 빠른 기기는 그대로 0.2초
     - 학생이 보낸 순간부터 3초는 분석을 쉰다 — 맞장구·첫 문장·다음 문장 준비가 몰리는 가장 급한 구간
       (첫 소리에서 끝내면 맞장구와 첫 문장 사이에 분석이 끼어 첫 문장이 ~0.3초 늦었다)
     - 피아가 말하는 동안은 0.6초 간격 */
  var BUDGET_X = 6, PLAY_MS = 600, QUIET_MS = 3000, MAX_MS = 2000;
  var detAvg = 0, detN = 0, quietUntil = 0, lastDelay = SAMPLE_MS;
  /* 학생이 말하는 동안(🎙 인식 중·말로 끼어든 중)은 입 벌림·고개 움직임이 말 때문이라 하품·끄덕임으로 세지 않는다 */
  var curTalk = false;
  function talking() {
    try {
      if (window._piaRec2) return true;
      var b = window.piaBargeIn && window.piaBargeIn.state && window.piaBargeIn.state();
      if (b && b.barged) return true;
    } catch (e) {}
    return false;
  }
  var btn = null, panel = null, lastAsk = -1e12;

  function log() { try { console.log.apply(console, ['[camera]'].concat([].slice.call(arguments))); } catch (e) {} }
  function el(id) { return document.getElementById(id); }
  function isKiosk() { return document.documentElement.classList.contains('kiosk-on'); }
  function off() { try { return localStorage.getItem('pia_cam') === '0'; } catch (e) { return false; } }
  function hasConsent() { try { return !!JSON.parse(localStorage.getItem(CONSENT_KEY) || 'null'); } catch (e) { return false; } }
  function setConsent(v) { try { if (v) localStorage.setItem(CONSENT_KEY, JSON.stringify({ at: new Date().toISOString(), v: 1 })); else localStorage.removeItem(CONSENT_KEY); } catch (e) {} }
  function toast(m) { try { if (typeof window.toast === 'function') window.toast(m); } catch (e) {} }

  /* ── 신호 → 힌트 (순수 함수, 검증용으로 내보냄) ───────────────── */
  function summarize(list) {
    var n = list.length;
    if (n < MIN_SAMPLES) return null;
    var face = 0, smile = 0, away = 0, frown = 0, motion = 0, nod = 0, shake = 0, now = list[n - 1].t;
    var closed = 0, run0 = -1, longClose = 0, yawns = 0, y0 = -1, surp = 0, surpAll = 0;
    for (var i = 0; i < n; i++) {
      var s = list[i];
      motion += s.motion || 0;
      if (now - s.t <= GESTURE_MS) { if (s.nod) nod++; if (s.shake) shake++; }
      /* 눈 감김이 이어진 시간, 하품(입 크게 벌림이 이어진 시간) — 얼굴이 사라지면 끊는다 */
      var shut = s.face && (s.eye || 0) >= EYE_CLOSED;
      if (shut) { if (run0 < 0) run0 = s.t; longClose = Math.max(longClose, s.t - run0); } else run0 = -1;
      var gape = s.face && !s.talk && (s.jaw || 0) >= YAWN_JAW;
      if (gape) { if (y0 < 0) y0 = s.t; } else { if (y0 >= 0 && s.t - y0 >= YAWN_MS) yawns++; y0 = -1; }
      if (!s.face) { away++; continue; }
      face++;
      if (shut) closed++;
      if (s.smile >= 0.45) smile++;
      if (s.frown >= 0.45 && s.smile < 0.2) frown++;
      if (s.turn >= 0.18) away++;
      if (!s.talk && (s.brow || 0) >= BROW_UP && ((s.wide || 0) >= EYE_WIDE || (s.jaw || 0) >= JAW_SURPRISE)) { surpAll++; if (now - s.t <= GESTURE_MS) surp++; }
    }
    if (y0 >= 0 && now - y0 >= YAWN_MS) yawns++;
    var cl = face ? closed / face : 0;
    var sleepy = cl >= PERCLOS || longClose >= LONG_CLOSE_MS || yawns >= 2 || (yawns >= 1 && cl >= 0.15);
    return { n: n, face: face / n, smile: face ? smile / face : 0, frown: face ? frown / face : 0, away: away / n, motion: motion / n, nod: nod, shake: shake,
             closed: cl, longClose: longClose, yawns: yawns, sleepy: sleepy,
             surprise: surp > 0 && face > 0 && surpAll / face < 0.4,
             focus: face / n >= 0.9 && away / n <= 0.1 && motion / n < RESTLESS * 0.4 && !sleepy && cl < 0.15 };
  }
  /* ask=true 이면 졸림을 '쉬어 가자'는 가벼운 권유 한 마디로 말하게 한다(3분에 한 번, piaCamHint 가 정함).
     화남·슬픔 같은 기분은 짐작해 말하지 않는다 — 말투만 바꾼다(OWNER 2026-10-01). */
  function hintFrom(sum, ask) {
    if (!sum || sum.face < 0.3) return '';          /* 얼굴이 거의 안 보이면 아무 말도 하지 않는다 */
    if (sum.sleepy && ask) {
      /* Flash-Lite 는 부드러운 '참고' 문구로는 권유를 거의 하지 않았다(0/3). '이번 답의 필수 규칙'으로 쓰면 6/6 따랐다(2026-10-01 측정). */
      return '\n\n[이번 답의 필수 규칙 — 다른 규칙보다 우선] 학생이 졸려 보인다. 이번 답의 첫 문장은 반드시 '
        + '"잠깐 기지개 켜고 할까?" 또는 "조금 쉬었다 할까?" 중 하나를 그대로 쓴다. 그 뒤에 하던 이야기를 한 문장으로 짧게 잇는다. '
        + '카메라·표정·"졸려 보인다"는 말하지 않고, 기분도 묻지 않는다.]';
    }
    var tip = '';
    if (sum.sleepy) tip = '졸려 보임 → 더 짧고 활기차게(쉬자는 권유는 이미 했으니 다시 하지 마)';
    else if (sum.shake) tip = '방금 고개를 가로저음 → 억지로 잇지 말고 다른 주제로 부드럽게 바꿔';
    else if (sum.nod) tip = '방금 고개를 끄덕임(이해·동의 신호) → 지금 이야기를 한 걸음 더 이어가';
    else if (sum.surprise) tip = '방금 눈이 커지고 눈썹이 올라감(놀람·흥미 신호일 수 있음) → 그 이야기를 한 걸음 더 풀어 줘';
    else if (sum.away >= 0.5) tip = '학생이 화면을 자주 벗어남 → 더 짧고 흥미로운 질문 하나로 주의를 끌어';
    else if (sum.motion >= RESTLESS) tip = '몸을 많이 움직임 → 짧고 경쾌하게, 몸을 쓰는 활동 이야기도 좋아';
    else if (sum.frown >= 0.4) tip = '표정이 굳어 보임 → 부담 없는 가벼운 질문으로, 재촉하지 말고';
    else if (sum.smile >= 0.35) tip = '웃는 표정이 자주 보임 → 지금 분위기와 주제를 이어가';
    else if (sum.focus) tip = '차분히 화면을 보며 집중하고 있음 → 지금 속도를 유지하고, 한 단계 더 생각해 볼 질문도 좋아';
    if (!tip) return '';
    return '\n[카메라 참고 신호 — 학생에게 표정·몸짓·카메라를 절대 언급하거나 평가하지 말고, 화남·슬픔 같은 기분을 짐작해 묻지도 말고, 말투·길이만 맞춰: ' + tip + ']';
  }
  window.piaCamHint = function () {
    if (!on) return '';
    var now = performance.now();
    var sum = summarize(samples.filter(function (s) { return now - s.t <= WINDOW_MS; }));
    var ask = !!(sum && sum.sleepy && sum.face >= 0.3 && now - lastAsk >= SLEEPY_ASK_MS);
    if (ask) lastAsk = now;
    return hintFrom(sum, ask);
  };

  /* ── 얼굴 → 거친 신호 ─────────────────────────────────────── */
  function toSample(res) {
    var s = { t: performance.now(), face: false, smile: 0, frown: 0, turn: 0, eye: 0, jaw: 0, brow: 0, wide: 0, motion: 0, nod: false, shake: false };
    try {
      if (!res || !res.faceLandmarks || !res.faceLandmarks.length) return s;
      s.face = true;
      var bs = (res.faceBlendshapes && res.faceBlendshapes[0] && res.faceBlendshapes[0].categories) || [];
      var g = {}; for (var i = 0; i < bs.length; i++) g[bs[i].categoryName] = bs[i].score;
      s.smile = ((g.mouthSmileLeft || 0) + (g.mouthSmileRight || 0)) / 2;
      s.frown = ((g.browDownLeft || 0) + (g.browDownRight || 0)) / 2;
      s.eye = ((g.eyeBlinkLeft || 0) + (g.eyeBlinkRight || 0)) / 2;
      s.jaw = g.jawOpen || 0;
      s.brow = ((g.browInnerUp || 0) + ((g.browOuterUpLeft || 0) + (g.browOuterUpRight || 0)) / 2) / 2;
      s.wide = ((g.eyeWideLeft || 0) + (g.eyeWideRight || 0)) / 2;
      /* 고개 돌림: 코끝(1)이 양 볼(234·454) 사이 가운데에서 얼마나 벗어났나(0 = 정면) */
      var L = res.faceLandmarks[0], a = L[234], b = L[454], nz = L[1];
      if (a && b && nz && b.x !== a.x) { s.turn = Math.abs((nz.x - a.x) / (b.x - a.x) - 0.5); headMove(s, nz, a, b); }
    } catch (e) { console.error('[camera] 신호 계산 실패', e); }
    return s;
  }

  /* ── 모션: 움직임 정도 + 고개 끄덕임·가로젓기 ─────────────────── */
  /* 움직임: 32×24 흑백으로 줄인 두 장면의 평균 차이(0~1). 픽셀은 이 기기 메모리에서만 쓰고 버린다. */
  var mcv = null, mctx = null, prevPix = null;
  function motionLevel() {
    try {
      if (!mcv) { mcv = document.createElement('canvas'); mcv.width = 32; mcv.height = 24; mctx = mcv.getContext('2d', { willReadFrequently: true }); }
      mctx.drawImage(video, 0, 0, 32, 24);
      var d = mctx.getImageData(0, 0, 32, 24).data, cur = new Uint8Array(768), sum = 0, i, j;
      for (i = 0, j = 0; i < d.length; i += 4, j++) cur[j] = (d[i] * 3 + d[i + 1] * 4 + d[i + 2]) >> 3;
      if (prevPix) for (i = 0; i < 768; i++) sum += Math.abs(cur[i] - prevPix[i]);
      var m = prevPix ? sum / 768 / 255 : 0;
      prevPix = cur;
      return m;
    } catch (e) { return 0; }
  }
  /* 고개: 코끝이 양 볼 가운데서 얼마나 떨어졌나(얼굴 너비로 나눔 — 몸 전체가 움직여도 상쇄된다).
     최근 2.5초 동안 위아래로 두 번 넘게 방향이 바뀌면 끄덕임, 좌우면 가로젓기. */
  var headBuf = [];
  function swings(arr) {
    var n = 0, dir = 0, hi = arr[0], lo = arr[0];
    for (var i = 1; i < arr.length; i++) {
      var v = arr[i];
      if (dir === 0) {
        if (v > hi) hi = v; if (v < lo) lo = v;
        if (hi - v >= HEAD_AMP) { dir = -1; lo = v; } else if (v - lo >= HEAD_AMP) { dir = 1; hi = v; }
      } else if (dir > 0) {
        if (v > hi) hi = v; else if (hi - v >= HEAD_AMP) { n++; dir = -1; lo = v; }
      } else {
        if (v < lo) lo = v; else if (v - lo >= HEAD_AMP) { n++; dir = 1; hi = v; }
      }
    }
    return n;   /* 방향이 뒤집힌 횟수 */
  }
  function range(a) { return Math.max.apply(null, a) - Math.min.apply(null, a); }
  function headMove(s, nz, a, b) {
    if (curTalk) { headBuf = []; return; }
    var w = Math.hypot(b.x - a.x, b.y - a.y);
    if (!w) return;
    headBuf.push({ x: (nz.x - (a.x + b.x) / 2) / w, y: (nz.y - (a.y + b.y) / 2) / w, t: s.t });
    while (headBuf.length && s.t - headBuf[0].t > 2500) headBuf.shift();
    if (headBuf.length < 6) return;
    var xs = headBuf.map(function (p) { return p.x; }), ys = headBuf.map(function (p) { return p.y; });
    var rx = range(xs), ry = range(ys);
    if (swings(ys) >= 2 && ry > rx * 1.5) { s.nod = true; headBuf = []; }
    else if (swings(xs) >= 2 && rx > ry * 1.5) { s.shake = true; headBuf = []; }
  }

  /* ── 모델·카메라 ─────────────────────────────────────────── */
  async function loadModel() {
    if (lm) return lm;
    var mod = await import(VENDOR + 'vision_bundle.mjs');
    var files = await mod.FilesetResolver.forVisionTasks(VENDOR + 'wasm');
    var opts = { baseOptions: { modelAssetPath: VENDOR + 'face_landmarker.task', delegate: 'GPU' }, runningMode: 'VIDEO', numFaces: 1, outputFaceBlendshapes: true };
    try { lm = await mod.FaceLandmarker.createFromOptions(files, opts); }
    catch (e) { log('GPU 실패 → CPU', e && e.message); opts.baseOptions.delegate = 'CPU'; lm = await mod.FaceLandmarker.createFromOptions(files, opts); }
    return lm;
  }
  function nextDelay() {
    /* 작업 스레드: 화면을 막지 않으므로 분석 시간의 1.5배 간격이면 충분(워커가 밀리지 않을 만큼만) */
    if (useWorker) return Math.min(MAX_MS, Math.max(SAMPLE_MS, Math.round(detAvg * 1.5)));
    var d = Math.max(SAMPLE_MS, Math.round(detAvg * BUDGET_X));
    try { if (window.__gttsPlaying) d = Math.max(d, PLAY_MS); } catch (e) {}
    return Math.min(d, MAX_MS);
  }
  function tick() {
    var now = performance.now();
    if (quietUntil && now >= quietUntil) quietUntil = 0;
    lastDelay = nextDelay();
    loopT = setTimeout(tick, lastDelay);
    if (useWorker) {
      /* 말하는 동안은 쉰다(입·고개를 하품·끄덕임으로 잘못 세지 않게). 보낸 뒤 쉬는 구간은 필요 없다. */
      if (!on || !wReady || !worker || !video || document.hidden || video.readyState < 2 || talking()) return;
      if (wPending && now - wPending < 3000) return;          /* 앞 장 결과를 기다리는 중 */
      wPending = now;
      var id = ++wSeq;
      createImageBitmap(video).then(function (bmp) {
        if (!on || !worker || !useWorker) { try { bmp.close(); } catch (e) {} wPending = 0; return; }
        worker.postMessage({ type: 'frame', id: id, bitmap: bmp, ts: performance.now() }, [bmp]);
      }).catch(function (e) { wPending = 0; lastErr = String(e && e.message || e); });
      return;
    }
    /* 학생이 말하는 동안도 쉰다 — 보내는 순간 분석이 겹쳐 맞장구가 늦는 일을 막고, 말하는 입·고개를 하품·끄덕임으로 잘못 세지 않는다 */
    if (!on || !lm || !video || document.hidden || video.readyState < 2 || busy || quietUntil || talking()) return;
    busy = true;
    try {
      var t0 = performance.now();
      curTalk = talking();
      var smp = toSample(lm.detectForVideo(video, t0));
      smp.talk = curTalk;
      var dt = performance.now() - t0;
      /* 처음 두 번은 모델 준비(수 초)가 섞여 있어 평균에서 뺀다 */
      if (++detN > 2) detAvg = detAvg ? detAvg * 0.7 + dt * 0.3 : dt;
      smp.motion = motionLevel();
      samples.push(smp);
      var cut = performance.now() - WINDOW_MS * 2;
      while (samples.length && samples[0].t < cut) samples.shift();
    } catch (e) { lastErr = String(e && e.message || e); console.error('[camera] 분석 실패', e); }
    busy = false;
  }

  async function start() {
    if (on) return;
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) { toast('이 브라우저는 카메라를 쓸 수 없어요.'); return; }
    setBtn('loading');
    try {
      stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user', width: { ideal: 320 }, height: { ideal: 240 }, frameRate: { ideal: 15 } }, audio: false });
    } catch (e) {
      console.error('[camera] 카메라 권한/장치 오류', e);
      toast(e && e.name === 'NotAllowedError' ? '카메라 사용이 허용되지 않았어요.' : '카메라를 찾지 못했어요.');
      setBtn('off'); return;
    }
    showPanel();
    video.srcObject = stream;
    try { await video.play(); } catch (e) {}
    on = true; samples = [];
    setBtn('on');
    useWorker = false;
    if (workerAllowed()) {
      try { if (!wReady) await loadWorker(); useWorker = true; log('표정 분석 준비 완료(작업 스레드, ' + wDelegate + ')'); }
      catch (e) { log('작업 스레드 준비 실패 → 화면 스레드', e && e.message); }
    }
    if (useWorker) { if (!on) return; clearTimeout(loopT); tick(); return; }
    try { await loadModel(); log('표정 분석 준비 완료'); }
    catch (e) { lastErr = String(e && e.message || e); console.error('[camera] 표정 분석 모델을 불러오지 못함', e); toast('표정 분석을 준비하지 못했어요. 카메라를 끌게요.'); stop('model'); return; }
    clearTimeout(loopT); tick();
  }
  function stop(why) {
    on = false; clearTimeout(loopT); loopT = null; samples = []; headBuf = []; prevPix = null; quietUntil = 0; detN = 0; detAvg = 0; wPending = 0;
    try { if (stream) stream.getTracks().forEach(function (t) { t.stop(); }); } catch (e) {}
    stream = null;
    try { if (video) video.srcObject = null; } catch (e) {}
    if (panel) panel.style.display = 'none';
    setBtn('off');
    log('꺼짐', why || '');
  }

  /* ── 화면 ─────────────────────────────────────────────── */
  function setBtn(st) {
    if (!btn) return;
    btn.dataset.state = st;
    btn.setAttribute('aria-pressed', st === 'on' ? 'true' : 'false');
    btn.textContent = st === 'on' ? '📷 켜짐' : st === 'loading' ? '📷 준비 중…' : '📷 표정';
    btn.style.background = st === 'on' ? '#fee2e2' : '';
  }
  function showPreview() { try { return localStorage.getItem('pia_cam_preview') === '1'; } catch (e) { return false; } }
  function showPanel() {
    if (!panel) {
      panel = document.createElement('div');
      panel.id = 'pia-cam-panel';
      panel.setAttribute('role', 'status');
      panel.style.cssText = 'position:fixed;right:12px;bottom:12px;z-index:60;background:#fff;border:1px solid #e5e7eb;border-radius:12px;padding:6px;box-shadow:0 4px 14px rgba(0,0,0,.12);font-size:11px;color:#374151;width:' + (showPreview() ? '132px' : 'auto;max-width:200px') + '';
      video = document.createElement('video');
      video.id = 'pia-cam-video'; video.muted = true; video.setAttribute('playsinline', ''); video.autoplay = true;
      /* [2026-10-01 OWNER '일단 화면에 이미지는 숨겨'] 얼굴 미리보기는 숨긴다. 분석에는 영상 프레임이 계속 필요해
         display:none 대신 2px·투명으로 둔다(숨긴 영상은 일부 브라우저가 프레임 갱신을 멈춤).
         '카메라 켜짐' 빨간 표시·끄기·동의 취소는 그대로 보인다. 현장 확인용: localStorage pia_cam_preview='1' 이면 미리보기. */
      video.style.cssText = showPreview()
        ? 'width:120px;height:90px;border-radius:8px;background:#111;transform:scaleX(-1);display:block;object-fit:cover'
        : 'position:absolute;width:2px;height:2px;opacity:0;pointer-events:none;left:0;top:0';
      video.setAttribute('aria-hidden', 'true');
      var row = document.createElement('div');
      row.style.cssText = 'display:flex;align-items:center;gap:4px;margin-top:4px;line-height:1.3';
      row.innerHTML = '<span style="width:8px;height:8px;border-radius:50%;background:#dc2626;display:inline-block;flex:none"></span><span>카메라 켜짐 · 이 기기 안에서만 분석</span>';
      var acts = document.createElement('div');
      acts.style.cssText = 'display:flex;gap:4px;margin-top:4px';
      var bOff = document.createElement('button'); bOff.type = 'button'; bOff.id = 'pia-cam-off'; bOff.textContent = '끄기';
      var bRev = document.createElement('button'); bRev.type = 'button'; bRev.id = 'pia-cam-revoke'; bRev.textContent = '동의 취소';
      [bOff, bRev].forEach(function (b) { b.style.cssText = 'flex:1;padding:3px 0;border:1px solid #d1d5db;border-radius:6px;background:#f9fafb;font-size:11px'; });
      bOff.addEventListener('click', function () { offSession = true; stop('off'); });
      bRev.addEventListener('click', function () { offSession = true; setConsent(false); stop('revoke'); toast('카메라 동의를 취소했어요.'); });
      acts.appendChild(bOff); acts.appendChild(bRev);
      panel.appendChild(video); panel.appendChild(row); panel.appendChild(acts);
      document.body.appendChild(panel);
    }
    panel.style.display = '';
  }
  function consentDialog() {
    return new Promise(function (resolve) {
      var ov = document.createElement('div');
      ov.id = 'pia-cam-consent';
      ov.setAttribute('role', 'dialog'); ov.setAttribute('aria-modal', 'true'); ov.setAttribute('aria-labelledby', 'pia-cam-consent-title');
      ov.style.cssText = 'position:fixed;inset:0;z-index:80;background:rgba(0,0,0,.45);display:flex;align-items:center;justify-content:center;padding:16px';
      ov.innerHTML =
        '<div style="background:#fff;border-radius:16px;max-width:420px;width:100%;padding:20px;font-size:14px;line-height:1.6;color:#111827">' +
        '<h2 id="pia-cam-consent-title" style="font-size:17px;font-weight:700;margin:0 0 10px">카메라로 표정을 보며 대화할까요?</h2>' +
        '<ul style="margin:0 0 12px;padding-left:18px">' +
        '<li>얼굴 영상은 <b>이 기기 안에서만</b> 분석하고, 저장하거나 서버로 보내지 않아요.</li>' +
        '<li>웃음·시선 같은 신호로 <b>대화 속도와 분위기만</b> 맞춰요. 검사 결과에는 쓰지 않아요.</li>' +
        '<li>졸려 보이면(눈 감김·하품) "잠깐 쉬었다 할까?"처럼 <b>쉬어 가자고 권할 수 있어요</b>. 기분(화남 등)은 짐작해서 묻지 않아요.</li>' +
        '<li>얼굴로 누구인지 알아내지 않고, 옷차림은 보지 않아요.</li>' +
        '<li>언제든 <b>끄기</b>·<b>동의 취소</b>를 누를 수 있어요.</li>' +
        '<li>처음 켤 때 표정 분석 파일(약 15MB)을 한 번 내려받아요.</li></ul>' +
        '<label style="display:flex;gap:8px;align-items:flex-start;background:#f3f4f6;border-radius:10px;padding:10px;margin-bottom:14px">' +
        '<input id="pia-cam-guardian" type="checkbox" style="margin-top:4px">' +
        '<span>만 14세 미만이라면 <b>보호자(또는 담임 선생님)가 동의</b>했어요. 만 14세 이상이면 본인이 동의해요.</span></label>' +
        '<div style="display:flex;gap:8px;justify-content:flex-end">' +
        '<button id="pia-cam-no" type="button" style="padding:8px 14px;border:1px solid #d1d5db;border-radius:10px;background:#fff">안 할래요</button>' +
        '<button id="pia-cam-yes" type="button" disabled style="padding:8px 14px;border:0;border-radius:10px;background:#111827;color:#fff;opacity:.4">동의하고 켜기</button></div></div>';
      document.body.appendChild(ov);
      var chk = ov.querySelector('#pia-cam-guardian'), yes = ov.querySelector('#pia-cam-yes'), no = ov.querySelector('#pia-cam-no');
      chk.addEventListener('change', function () { yes.disabled = !chk.checked; yes.style.opacity = chk.checked ? '1' : '.4'; });
      function done(v) { ov.remove(); resolve(v); }
      yes.addEventListener('click', function () { if (chk.checked) { setConsent(true); done(true); } });
      no.addEventListener('click', function () { done(false); });
      ov.addEventListener('keydown', function (e) { if (e.key === 'Escape') done(false); });
      setTimeout(function () { try { chk.focus(); } catch (e) {} }, 0);
    });
  }

  /* [2026-10-01 OWNER '이 버튼 없애고 카메라 기능은 동일하게'] 📷 버튼 없이 동작한다.
     AI 대화 화면에 들어오면
       - 이미 동의한 기기 → 카메라를 자동으로 켠다(빨간 '카메라 켜짐' 표시·끄기·동의 취소는 그대로)
       - 동의 전 → 1.5초 뒤 동의 창을 띄운다(보호자 확인 체크 필수). '안 할래요'면 7일 동안 다시 묻지 않음
     대화 화면을 떠나거나 화면이 숨겨지면 끄고, 돌아오면 다시 켠다.
     '끄기'·'동의 취소'·권한 거부·모델 실패 뒤에는 이번 방문 동안 다시 켜지 않는다.
     키오스크·pia_cam='0' 이면 묻지도 켜지도 않는다.
     자동화 브라우저(navigator.webdriver)에서는 동의 창을 자동으로 띄우지 않는다 — 다른 화면 점검이 가려지지 않게.
     (localStorage pia_cam_autoask='1' 이면 띄움 — 카메라 점검용) */
  /* [2026-10-01 OWNER '카메라로 표정을 보며 대화할까요? 팝업 안나오게'] 동의 창을 저절로 띄우지 않는다.
     이미 동의한 기기에서만 대화 화면에 들어올 때 켜진다. 동의 창은 window.piaCam.ask() 를 부를 때만 뜬다
     (동의 없이 카메라를 켜는 길은 없다 — 만 14세 미만은 보호자 동의가 필요). */
  var DECLINE_DAYS = 7, offSession = false, asking = false, starting = false, chatSince = 0, askReq = false;
  function onChat() { try { var v = document.querySelector('section[data-view]:not(.hidden)'); return !!v && v.getAttribute('data-view') === 'chat'; } catch (e) { return false; } }
  function declinedRecently() { try { var t = +localStorage.getItem('pia_cam_declined_at') || 0; return !!t && Date.now() - t < DECLINE_DAYS * 864e5; } catch (e) { return false; } }
  function setDeclined(v) { try { if (v) localStorage.setItem('pia_cam_declined_at', String(Date.now())); else localStorage.removeItem('pia_cam_declined_at'); } catch (e) {} }
  function autoStart() {
    if (on || starting) return;
    starting = true;
    Promise.resolve(start()).catch(function (e) { console.error('[camera] 자동 켜기 실패', e); })
      .then(function () { starting = false; if (!on) offSession = true; });   /* 권한 거부·모델 실패 → 이번 방문엔 다시 시도하지 않음 */
  }
  function check() {
    var blocked = off() || isKiosk();
    if (blocked || !onChat() || document.hidden) { chatSince = 0; if (on) stop(blocked ? 'kiosk/off' : 'leave'); return; }
    if (!chatSince) chatSince = Date.now();
    if (on || starting || asking || offSession) return;
    if (hasConsent()) { autoStart(); return; }
    if (!askReq) return;                 /* 저절로 묻지 않음 */
    askReq = false;
    asking = true;
    consentDialog().then(function (ok) {
      asking = false;
      if (ok) { setDeclined(false); autoStart(); }
      else { offSession = true; setDeclined(true); }
    });
  }
  setInterval(check, 1000);

  document.addEventListener('visibilitychange', function () { if (document.hidden && on) stop('hidden'); });
  /* 학생이 보내는 순간(🎙 자동 전송·끼어들기도 #chat-send 를 누른다) → 첫 소리까지 분석 쉼 */
  function quiet() { if (on) quietUntil = performance.now() + QUIET_MS; }
  document.addEventListener('click', function (e) { var t = e.target && e.target.closest ? e.target.closest('#chat-send') : null; if (t) quiet(); }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Enter' && !e.isComposing && e.target && e.target.id === 'chat-input') quiet(); }, true);
  window.addEventListener('pagehide', function () { if (on) stop('pagehide'); });

  window.piaCam = {
    state: function () { var sm = summarize(samples) || {}; return { on: on, detMs: Math.round(detAvg), delayMs: lastDelay, quiet: !!quietUntil, consent: hasConsent(), model: !!lm || wReady, worker: useWorker, delegate: useWorker ? wDelegate : (lm ? 'main' : ''), samples: samples.length, err: lastErr, motionAvg: samples.length ? samples.reduce(function (a, x) { return a + (x.motion || 0); }, 0) / samples.length : 0, nod: sm.nod || 0, shake: sm.shake || 0, closed: sm.closed || 0, longClose: sm.longClose || 0, yawns: sm.yawns || 0, sleepy: !!sm.sleepy, tracks: stream ? stream.getTracks().map(function (t) { return t.readyState; }) : [] }; },
    stop: stop,
    /* 다시 켜기·다시 묻기: 거절·끄기 기록을 지우고 바로 확인(동의돼 있으면 켜고, 아니면 동의 창) */
    ask: function () { offSession = false; setDeclined(false); chatSince = 1; askReq = true; check(); },
    _check: check, _status: function () { return { offSession: offSession, asking: asking, starting: starting, declined: declinedRecently() }; },
    _summarize: summarize, _hintFrom: hintFrom, _toSample: toSample, _swings: swings, _headMove: headMove, _resetHead: function () { headBuf = []; }, _resetAsk: function () { lastAsk = -1e12; },
    _push: function (arr) { (arr || []).forEach(function (x) { x.t = performance.now(); samples.push(x); }); }   /* 검증용 */
  };
})();
